// withParams.js
import { useParams } from "react-router-dom";

export const withParams = (Component) => {
  return props => <Component {...props} params={useParams()} />;
};

// import { useParams } from 'react-router-dom';

// function withParams(Component) {
//   return function WrappedComponent(props) {
//     const params = useParams();
//     return <Component {...props} params={params} />;
//   };
// }
